import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "modal" }

import {onBeforeMount, ref} from "vue"
  import Button from "@/components/button.vue"
  import {InvalidCredentialsError} from "@/endpoints/rutsolve/gql/errors/invalid_credentials"
  import {InvalidTokenError} from "@/endpoints/rutsolve/gql/errors/invalid_token"
  import {SuspendedError} from "@/endpoints/rutsolve/gql/errors/suspended"
  import {UnauthorizedError} from "@/endpoints/rutsolve/gql/errors/unauthorized"
  import router from "@/router"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'error',
  props: {
    "error": {
    default: null,
    required: true,
    type: Error
  },
    "errorModifiers": {},
  },
  emits: ["update:error"],
  setup(__props) {

  const error = _useModel(__props, "error")

  const redirectSession = ref<boolean>(false)
  const message = ref<string>(null)
  const title = ref<string>(null)

  onBeforeMount(() => {
    extractError()
  })

  function extractError() {
    message.value = error.value.message
    title.value = "Error"

    if (error.value instanceof InvalidCredentialsError) {
      message.value = "Invalid credentials."
      title.value = "Authentication Error"
    }

    if (error.value instanceof InvalidTokenError) {
      redirectSession.value = true
      message.value = "Invalid token."
      title.value = "Authentication Error"
    }

    if (error.value instanceof SuspendedError) {
      message.value = "Account suspended."
      title.value = "Authentication Error"
    }

    if (error.value instanceof UnauthorizedError) {
      redirectSession.value = true
      message.value = "No permission for this action."
      title.value = "Authorization Error"
    }
  }

  function sessionRedirect() {
    router.push({
      name: "session"
    })
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", null, _toDisplayString(title.value), 1),
          _createElementVNode("p", null, _toDisplayString(message.value), 1),
          _createVNode(Button, {
            title: "Close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (error.value = null))
          }),
          (redirectSession.value)
            ? (_openBlock(), _createBlock(Button, {
                key: 0,
                title: "Session",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (sessionRedirect()))
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})